import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { rootUrl } from '../../config/config';
import { useAuth } from '../../components/myTrack/AuthContext';

export default function RolesPage() {
    const { user, token } = useAuth();
    const [roles, setRoles] = useState([]);
    const [perms, setPerms] = useState([]);
    const [editing, setEditing] = useState(null);
    const headers = { Authorization: `Bearer ${token}` };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fetchAll(); }, []);

    async function fetchAll() {
        try {
            const [r1, r2] = await Promise.all([
                axios.get(`${rootUrl}/api/roles`, { headers }),
                axios.get(`${rootUrl}/api/permissions`, { headers })
            ]);
            setRoles(r1.data.data || []);
            setPerms((r2.data.data || []).map(p => ({ value: p.id, label: `${p.key} — ${p.name}` })));
        } catch (err) {
            console.error(err);
        }
    }

    async function saveRole() {
        try {
            const body = { name: editing.name, description: editing.description, permissionIds: (editing.permissions || []).map(p => p.value), input_by: user?.username };
            if (editing.id) await axios.put(`${rootUrl}/api/roles/${editing.id}`, body, { headers });
            else await axios.post(`${rootUrl}/api/roles`, body, { headers });
            fetchAll();
            setEditing(null);
        } catch (err) { console.error(err); }
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#fff8f5] to-[#EDE4DA]">
            <div className="p-6 lg:p-8 text-center mb-8">
                <h1 className="text-4xl font-bold text-[#2a2e30] mb-2">Roles & Permissions</h1>
                <div className="w-24 h-1 bg-[#FF5733] mx-auto rounded-full mb-4"></div>
                <p className="text-lg text-[#2a2e30] opacity-80">Create, edit roles and assign permissions</p>
            </div>
            <div className="w-full max-w-7xl mx-auto px-2 sm:px-4 pb-8">
                <div className="bg-white rounded-2xl shadow-xl p-6">
                    <div className="mb-4 flex justify-between">
                        <button onClick={() => setEditing({ name: '', description: '', permissions: [] })} className="bg-[#FF5733] hover:bg-[#e64520] text-white text-sm font-semibold rounded-sm px-3 py-1">New Role</button>
                    </div>
                    <div>
                        {roles.map(r => (
                            <div key={r.id} className="flex items-center justify-between border-b py-3">
                                <div>
                                    <div className="font-semibold">{r.name}</div>
                                    <div className="text-sm text-gray-600">{r.description}</div>
                                </div>
                                <div>
                                    <button onClick={async () => { const res = await axios.get(`${rootUrl}/api/roles/${r.id}`, { headers }); const role = res.data.data || {}; const permRes = await axios.get(`${rootUrl}/api/permissions`, { headers }); const allPerms = (permRes.data.data || []); const mapped = allPerms.map(p => ({ value: p.id, label: `${p.key} — ${p.name}` })); const selected = mapped.filter(m => (role.permissionIds || []).includes(m.value)); setEditing({ ...role, permissions: selected }); }} className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm rounded-sm px-3 py-1 mr-2">Edit</button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {editing && (
                        <div className="mt-6">
                            <label className="block">Name</label>
                            <input className="w-full p-2 border rounded" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} />
                            <label className="block mt-3">Description</label>
                            <input className="w-full p-2 border rounded" value={editing.description} onChange={e => setEditing({ ...editing, description: e.target.value })} />
                            <label className="block mt-3">Permissions</label>
                            <Select isMulti options={perms} value={editing.permissions} onChange={(v) => setEditing({ ...editing, permissions: v })} />
                            <div className="mt-4">
                                <button onClick={saveRole} className="bg-[#FF5733] hover:bg-[#e64520] text-white text-sm font-semibold rounded-sm px-3 py-1 mr-2">Save</button>
                                <button onClick={() => setEditing(null)} className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm rounded-sm px-3 py-1">Cancel</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
